import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AppShellSkeleton from './AppShellSkeleton';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <AppShellSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Vérifier si l'utilisateur est admin ou moderator
  if (user?.role === 'user') {
    return <Navigate to="/overview" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute; 